(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["key-ingredients"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.kiReady) return;
      var track = root.querySelector('[data-key-ingredients-track]');
      var dots = root.querySelectorAll('.key-ingredients__dot');
      var prev = root.querySelector('[data-key-ingredients-prev]');
      var next = root.querySelector('[data-key-ingredients-next]');
      if (!track || !dots.length) return;
      root.dataset.kiReady = 'true';
      var cards = Array.prototype.slice.call(track.children);

      function current() {
        var origin = cards[0].offsetLeft;
        var left = track.scrollLeft;
        var closest = 0;
        var min = Infinity;
        cards.forEach(function (card, i) {
          var d = Math.abs(card.offsetLeft - origin - left);
          if (d < min) { min = d; closest = i; }
        });
        return closest;
      }
      function update() {
        var i = current();
        dots.forEach(function (dot, j) { dot.classList.toggle('is-active', j === i); });
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = atEnd;
      }
      function go(i) {
        i = Math.max(0, Math.min(cards.length - 1, i));
        track.scrollTo({ left: cards[i].offsetLeft - cards[0].offsetLeft, behavior: 'smooth' });
      }

      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      if (prev) prev.addEventListener('click', function () { go(current() - 1); });
      if (next) next.addEventListener('click', function () { go(current() + 1); });
      update();
    }
    function initAll() {
      document.querySelectorAll('[data-key-ingredients]').forEach(init);
    }
    initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slide-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.scReady) return;
      var track = root.querySelector('[data-slide-cards-track]');
      if (!track) return;
      root.dataset.scReady = 'true';
      var slides = Array.prototype.slice.call(track.children);
      var prev = root.querySelector('[data-slide-cards-prev]');
      var next = root.querySelector('[data-slide-cards-next]');
      var dots = root.querySelectorAll('[data-slide-cards-dot]');
      var loop = root.dataset.loop === 'true';
      var autoplay = root.dataset.autoplay === 'true';
      var speed = (parseInt(root.dataset.speed, 10) || 5) * 1000;
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var timer = null;

      function current() {
        var width = track.clientWidth || 1;
        return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / width)));
      }
      function update() {
        var i = current();
        dots.forEach(function (dot, j) {
          dot.classList.toggle('is-active', j === i);
          if (j === i) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
        });
        if (!loop) {
          if (prev) prev.disabled = i === 0;
          if (next) next.disabled = i === slides.length - 1;
        }
      }
      function go(i) {
        if (i < 0) i = loop ? slides.length - 1 : 0;
        if (i > slides.length - 1) i = loop ? 0 : slides.length - 1;
        track.scrollTo({ left: i * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
      }

      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      if (prev) prev.addEventListener('click', function () { go(current() - 1); });
      if (next) next.addEventListener('click', function () { go(current() + 1); });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () { go(parseInt(dot.dataset.slideCardsDot, 10)); });
      });
      root.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') go(current() - 1);
        if (event.key === 'ArrowRight') go(current() + 1);
      });

      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() {
        if (!autoplay || reduced || slides.length < 2) return;
        stop();
        timer = setInterval(function () {
          var i = current();
          go(i === slides.length - 1 ? 0 : i + 1);
        }, speed);
      }
      ['mouseenter', 'focusin', 'touchstart'].forEach(function (name) {
        root.addEventListener(name, stop, { passive: true });
      });
      ['mouseleave', 'focusout', 'touchend'].forEach(function (name) {
        root.addEventListener(name, start, { passive: true });
      });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else start();
      });

      update();
      start();
    }
    function initAll() {
      document.querySelectorAll('[data-slide-cards]').forEach(init);
    }
    initAll();
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', function (event) {
      var slide = event.target;
      var track = slide.closest && slide.closest('[data-slide-cards-track]');
      if (track) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'auto' });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
